import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Box, Container } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import { useParams } from 'react-router-dom';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import SettlementByWasherListResults from 'src/components/settlement/SettlementByWasherListResult';
import SettlementDetailsListToolBar from 'src/components/settlement/SettlementDetailsListToolBar';
import { api } from 'src/service';
import TransactionDetail from '../../components/settlement/TransactionDetail';
import { usePersistedPagerInfo } from 'src/utils/usePersistedLimit';

const SettlementDetails = () => {
  const [transactionDetail, setTransactionDetail] = useState();
  const [payments, setPayments] = useState();
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [open, setOpen] = useState(false);
  const [searchStr, setSearchStr] = useState('');
  const [pagerInfo, setPagerInfo] = usePersistedPagerInfo('settlementDetails', { limit: 10 });
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const params = useParams();

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        await api
          .post('/backoffice/payments/filter', {
            page_size: pagerInfo.limit,
            current_page: pagerInfo.page,
            search: searchStr,
            washer_id: params.washerId,
          })
          .then((res) => {
            setPayments(res.data.data.data);
            setPagerInfo({
              limit: res.data.data.page_size,
              page: res.data.data.current_page,
              totalSize: res.data.data.total_size,
            });
          });
      } catch (error) {
        console.error(error.message);
      }
      setLoading(false);
    };

    fetchData();
  }, [searchStr, pagerInfo.page, pagerInfo.limit]);

  useEffect(() => {
    setLoading2(true);
    if (!params.washerId) {
      setLoading2(false);
      return;
    }
    api.get(`/income/${params.washerId}`).then((res) => {
      const { data } = res;
      setTransactionDetail(data.data);
      setLoading2(false);
    });
  }, [params.washerId]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleSearchStr = (str) => {
    setSearchStr(str);
  };

  const handlePagerInfo = (info) => {
    setPagerInfo(info);
  };

  return (
    <>
      <Helmet>
        <title>Washer - Settlement Details</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3,
        }}
      >
        <Container maxWidth={false}>
          <SettlementDetailsListToolBar
            handleSearchStr={handleSearchStr}
            id={params.washerId}
          />
          <Box sx={{ pt: 3 }}>
            <SettlementByWasherListResults
              payments={payments}
              handlePagerInfo={handlePagerInfo}
              pagerInfo={pagerInfo}
              loading={loading}
            />
          </Box>
          <Box sx={{ pt: 3 }}>
            <TransactionDetail
              transactionDetail={transactionDetail}
              loading={loading2}
              wallet={transactionDetail}
            />
          </Box>
          <Dialog
            fullScreen={fullScreen}
            open={open}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogTitle id="responsive-dialog-title">Confirmation</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Are you sure you want to remove it?
              </DialogContentText>
            </DialogContent>
          </Dialog>
        </Container>
      </Box>
    </>
  );
};

export default SettlementDetails;
